export enum TextObjectKinds {
  Free = 0,
  Fixed = 1,
  Number = 2,
  HisItem = 3,
  UserDefined = 4,
  DesignatedDoctorNumber = 5,
  RangeOfMotion = 6,
}
